import { css } from 'lit';

export const styles = css `
  .container {
    cursor: text;
  }

  :host([disabled]) .container {
    cursor: default;
  }
`;
